
































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Str } from '@/modules/shared/helpers'
import { Prop, Watch } from 'vue-property-decorator'

const defaultFormats = [
  'jpg',
  'bmp',
  'png',
  'html',
  'txt',
  'docx',
  'doc',
  'xls',
  'csv',
  'zip',
  'rar'
]

@Component
export default class Uploader extends Vue {
  constructor(
    private readonly str: Str
  ) {
    super()
  }

  @Prop() protected value

  @Prop({
    default: () => defaultFormats
  }) formats!: typeof defaultFormats

  @Prop({
    default: 3
  }) maxFiles!: number

  @Prop() label!: string

  showHeader(filesLength: number) {
    return (filesLength > 0) && (filesLength < this.maxFiles)
  }

  @Watch('value', {
    immediate: true
  })
  propChange() {
    if (this.$refs.uploader) {
      this.setFiles()
    } else {
      this.$nextTick(this.setFiles)
    }
  }

  setFiles() {
    ;(this.$refs.uploader as any).files = this.value
  }

  fileChange() {
    const files = (this.$refs.uploader as any).files
    this.$emit('input', files)
  }
}
